import { Menu } from 'lucide-react';
import { APP } from '../tokens';

interface MobileDocumentHeaderProps {
  title: string;
  versionLabel?: string | null;
  onMenu?: () => void;
  onVersionClick?: () => void;
  onShare?: () => void;
  onDownload?: () => void;
  onDownloadDocx?: () => void;
}

export default function MobileDocumentHeader({
  title,
  versionLabel,
  onMenu,
  onVersionClick,
  onShare,
  onDownload,
  onDownloadDocx,
}: MobileDocumentHeaderProps) {
  return (
    <div
      style={{
        height: 52,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '0 10px',
        borderBottom: `1px solid ${APP.borderDocTopBar}`,
        background: '#FAF7F4',
        boxSizing: 'border-box',
      }}
    >
      {onMenu && (
        <button
          type="button"
          aria-label="Open navigation"
          onClick={onMenu}
          style={{
            width: 34,
            height: 34,
            display: 'grid',
            placeItems: 'center',
            borderRadius: 9,
            border: `1px solid ${APP.border}`,
            background: APP.bgVersionCard,
            color: APP.textPrimary,
          }}
        >
          <Menu size={18} />
        </button>
      )}
      <div style={{ minWidth: 0, flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <span
          style={{
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontFamily: APP.fontFamily,
            fontSize: 13,
            fontWeight: 700,
            color: APP.textPrimary,
            lineHeight: '16px',
          }}
        >
          {title}
        </span>
        {versionLabel && (
          <button
            type="button"
            onClick={onVersionClick}
            style={{
              alignSelf: 'flex-start',
              maxWidth: '100%',
              border: `1px solid ${APP.border}`,
              borderRadius: 999,
              padding: '2px 8px',
              background: APP.bgVersionCard,
              color: APP.textSecondary,
              fontFamily: APP.fontFamily,
              fontSize: 10,
              lineHeight: '13px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {versionLabel}
          </button>
        )}
      </div>
      {onShare && (
        <button
          type="button"
          aria-label="Share"
          onClick={onShare}
          style={{
            height: 34,
            padding: '0 10px',
            borderRadius: 9,
            border: 'none',
            background: APP.bgChatSendBtn,
            color: '#FDFCFB',
            fontFamily: APP.fontFamily,
            fontSize: 12,
            fontWeight: 700,
          }}
        >
          Share
        </button>
      )}
      {onDownload && (
        <button
          type="button"
          aria-label="Download"
          onClick={onDownload}
          style={{
            width: 34,
            height: 34,
            display: 'grid',
            placeItems: 'center',
            borderRadius: 9,
            border: `1px solid ${APP.border}`,
            background: APP.bgVersionCard,
          }}
        >
          <svg width="15" height="15" viewBox="0 0 14 14" fill="none">
            <path d="M7 2v7M4 6.5L7 10l3-3.5M2 11h10" stroke={APP.textSecondary} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      )}
      {onDownloadDocx && (
        <button
          type="button"
          aria-label="Download as Word"
          onClick={onDownloadDocx}
          style={{
            height: 34,
            padding: '0 8px',
            display: 'grid',
            placeItems: 'center',
            borderRadius: 9,
            border: `1px solid ${APP.border}`,
            background: APP.bgVersionCard,
            color: APP.textSecondary,
            fontFamily: APP.fontFamily,
            fontSize: 10,
            fontWeight: 800,
          }}
        >
          DOCX
        </button>
      )}
    </div>
  );
}
